(function () {

  const scrollTop = () => {
    const btnScrollTop = document.querySelector('.scroll-top');

    window.addEventListener('scroll', function () {
      if (btnScrollTop) {
        if (
          scrollY > document.documentElement.clientHeight &&
          !document.querySelector('.menu-drawer-container[open]')
        ) {
          btnScrollTop.classList.add('show');
        } else {
          btnScrollTop.classList.remove('show');
        }
      }
    });

    document.addEventListener('toggle', function (event) {
      if (event.target.matches('.menu-drawer-container')) {
        if (event.target.open) {
          btnScrollTop.classList.remove('show');
        } else if (scrollY > document.documentElement.clientHeight) {
          btnScrollTop.classList.add('show');
        }
      }
    }, true);

    btnScrollTop.onclick = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }

  scrollTop();

  document.addEventListener("shopify:section:load", function () {
    scrollTop();
  })

})()